import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/styles';
import { tabsStyles } from './material-styles';

const VerticalTabs = withStyles(tabsStyles)(Tabs);

export default VerticalTabs;
